export { HowItWorksModal } from './HowItWorksModal';
export { default } from './HowItWorksModal';
